import axios from 'axios';

import elpPathService from './elpPathService';

const httpService = axios.create({
    baseURL: elpPathService.basePath.api
});

export default httpService;


// WEBPACK FOOTER //
// ./src/common/httpService.js